module.exports = __webpack_public_path__ + "img/user2.bc0340d4.png";